module.exports = __webpack_public_path__ + "static/assets/87924d6354694a1b40c4404b39f783d7.png";